import { render, staticRenderFns } from "./showtruckage.vue?vue&type=template&id=791e5748"
import script from "./showtruckage.vue?vue&type=script&lang=js"
export * from "./showtruckage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports